import i18n from 'i18next';
import en from './locales/en';
import { initReactI18next } from 'react-i18next';

const availableTranslations = [
  'en',
  'es',
  'fr',
  'de',
  'tr',
  'pt',
  'ja',
  'ru',
  'he',
];

const getSystemLanguage = () => {
  const userLanguage = navigator.language;
  const systemLanguage = userLanguage.split('-')[0];
  return availableTranslations.includes(systemLanguage) ? systemLanguage : 'en';
};

const lang = getSystemLanguage();

i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: lang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

if (lang !== 'en') {
  import(`./locales/${lang}.ts`).then((module) => {
    i18n.addResourceBundle(lang, 'translation', module.default, true, true);
  });
}

export default i18n;
